if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function <T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
    return [...this].sort(compareFn);
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function <T>(this: T[], index: number): T | undefined {
    const len = this.length;
    const relativeIndex = index < 0 ? len + index : index;
    if (relativeIndex < 0 || relativeIndex >= len) return undefined;
    return this[relativeIndex];
  };
}
